import {KnowledgeRagTopic} from 'common/src/modules/ai/ai.enums';
import formatFullAnswer from './utils/formatFullAnswer';
import formatRawResources from './utils/formatRawResources';
import {ToolExecuteParams, ToolResult} from '../../copilot.types';
import aiApi from 'common/src/modules/ai/ai.api';
import toolResult from '../../utils/creators/toolResult';
import tool from '../../utils/creators/tool';
import {ToolName} from '../../copilot.enums';
import {askKnowledgeRAGToolSchema} from '../../copilot.schemas';

function askKnowledgeRAGTool({
  topics,
  includeFullAnswer = true,
}: {
  topics: KnowledgeRagTopic[];
  includeFullAnswer?: boolean;
}) {
  async function execute({
    input: {prompt, context},
    toolUtils: {abortSignal},
  }: ToolExecuteParams<typeof askKnowledgeRAGToolSchema>): Promise<ToolResult> {
    const response = await aiApi.askKnowledgeRAG({
      prompt,
      context,
      topics,
      includeFullAnswer,
      abortSignal,
    });

    const formattedContent = includeFullAnswer
      ? formatFullAnswer(response)
      : formatRawResources(response);

    return toolResult(formattedContent);
  }

  const topicsList = topics.join(', ');
  const description = `Gather detailed information, best-practices and guidelines for the following subjects: ${topicsList}.`;

  return tool({
    name: ToolName.AskKnowledgeRAG,
    displayName: 'Gathering information',
    description,
    execute,
    inputSchema: askKnowledgeRAGToolSchema,
  });
}

export default askKnowledgeRAGTool;
